/*
 * How-to-brew tabs (snippets/850-brew-guide.liquid). Every brew method is
 * already printed server-side; this only switches which panel shows and moves
 * the underline. Arrow keys, Home and End move between tabs, following the
 * WAI-ARIA tabs pattern with automatic activation.
 */
class BrewTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index, true));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    const start = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    this.select(start < 0 ? 0 : start, false);
  }

  onKeydown(event, index) {
    const last = this.tabs.length - 1;
    const target = {
      ArrowRight: index === last ? 0 : index + 1,
      ArrowLeft: index === 0 ? last : index - 1,
      Home: 0,
      End: last,
    }[event.key];
    if (target === undefined) return;

    event.preventDefault();
    this.select(target, true);
    this.tabs[target].focus();
  }

  select(index, byUser) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, i) => {
      const active = i === index;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    this.style.setProperty('--brew-active', index);
    // The panel fade only plays after a shopper picks a tab, not on page load.
    if (byUser) this.classList.add('is-interacted');
  }
}

if (!customElements.get('brew-tabs')) customElements.define('brew-tabs', BrewTabs);
